var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-view"}},_vm._l((_vm.concerts),function(concert,index){return _c('Concert',{key:concert.id,ref:'anchor-' + concert.id,refInFor:true,attrs:{"domId":index,"concert":concert,"userId":_vm.userId},on:{"concertDeleted":_vm.removeConcert}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7940380","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Intern.vue
// module id = null
// module chunks = 